import { render, staticRenderFns } from "./VGraph.vue?vue&type=template&id=a2c51bc8&scoped=true&"
import script from "./VGraph.vue?vue&type=script&lang=js&"
export * from "./VGraph.vue?vue&type=script&lang=js&"
import style0 from "./VGraph.vue?vue&type=style&index=0&id=a2c51bc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c51bc8",
  null
  
)

export default component.exports